import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { formatDate, rootUrl } from '../../../helpers';
import { GiCheckeredDiamond } from 'react-icons/gi';
import SlidingDiv from '../../../components/slidingDiv';
import { spacing } from '@mui/system';


export default function LabMinerals() {
  const [minerals, setMinerals] = useState([]);
  const [selectedMineral, setSelectedMineral] = useState(null);
  const [assessmentData, setAssessmentData] = useState({
        p_processing_type: '',
        s_processing_type: '',
        weight_in_grams: '',
        comment: '',
        percentage: '',
  });

  

  const fetchMinerals = async () => {
    try {
      const response = await axios.get(rootUrl('/get-minerals'));
      console.log(response)
      const filteredMinerals = response.data.data.filter(
        (mineral) => mineral.status === 'Pending'
      );
      setMinerals(filteredMinerals);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAssessmentReport = async (mineralId) => {
    try {
      const response = await axios.get(rootUrl(`/get-assessment-report/${mineralId}`));
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  // Add assessment data to the selected mineral
  const addAssessmentData = async () => {
    if (!selectedMineral) return;

    const data = {
      ...assessmentData,
      mineral_id: selectedMineral.id,
    };

    try {
      const response = await axios.post(rootUrl('/add-assessment'), data);
      toast.success(response.data.message);
      fetchMinerals()
      toggleSlidingDiv()
      
      const report = await fetchAssessmentReport(selectedMineral.id);
      if (report) {
        setSelectedMineral({ ...selectedMineral, assessment_report: report });
      }

      setAssessmentData({
        p_processing_type: '',
        s_processing_type: '',
        weight_in_grams: '',
        comment: '',
        percentage: '',
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchMinerals();
  }, []);

  const [isSlidingDivVisible, setIsSlidingDivVisible] = useState(false);

  const toggleSlidingDiv = () => {
    setIsSlidingDivVisible(!isSlidingDivVisible);
  };

  const addLabData = (mineral)=>{
    setIsSlidingDivVisible(true)
    setSelectedMineral(mineral)
}

  return (
    <div className='p-4  shadow-lg rounded-lg'>
        <div>
        <h2 className="text-xl font-bold flex items-center"> <GiCheckeredDiamond/> Lab Minerals</h2>
        </div>

        <hr />

      {/* Display minerals with status Pending or In Lab */}
      {minerals.length > 0? (
        <div className="mt-4">
          <h3 className="text-lg font-semibold">Minerals Pending in Lab</h3>
          <table className="table-auto w-full border-collapse border border-gray-300 mt-4 rounded-lg">
  <thead>
    <tr className="bg-green-700 text-white">
      <th className="border border-gray-300 p-2 text-left">Type</th>
      <th className="border border-gray-300 p-2 text-left">Processing Type</th>
      <th className="border border-gray-300 p-2 text-left">Seller</th>
      <th className="border border-gray-300 p-2 text-left">Weight (grams)</th>
      <th className="border border-gray-300 p-2 text-left">Date</th>
    </tr>
  </thead>
  <tbody>
    {minerals.map((mineral) => (
      <tr
        key={mineral.id}
        className="hover:bg-gray-100 cursor-pointer"
        // onClick={() => setSelectedMineral(mineral)}
        onClick={() => addLabData(mineral)}
      >
        <td className="border border-gray-300 p-2">{mineral.type}</td>
        <td className="border border-gray-300 p-2">{mineral.processing_type}</td>
        <td className="border border-gray-300 p-2">{mineral.name}</td>
        <td className="border border-gray-300 p-2">{mineral.init_weight}</td>
        <td className="border border-gray-300 p-2">{formatDate(mineral.date.substring(0,10))}</td>
      </tr>
    ))}
  </tbody>
</table>

        </div>
      ):(
        <span className='my-5 text-semibold text-lg'>
            No minerals to display
        </span>
      )}

      {/* Show selected mineral details and add assessment form */}
      
      <SlidingDiv
        isVisible={isSlidingDivVisible}
        onClose={toggleSlidingDiv}
        width="w-1/3"
        backgroundColor="bg-white" 
        textColor="text-vlack"
      >
      {selectedMineral && (
        <div className="mt-4">
          <h3 className="text-lg font-semibold">Add Data for {selectedMineral.type}</h3>

          {/* Form to add data */}
          <input
            type="text"
            placeholder="Primary Processing Type"
            value={assessmentData.p_processing_type}
            onChange={(e) => setAssessmentData({ ...assessmentData, p_processing_type: e.target.value })}
            className="border p-2 rounded w-full mb-2"
          />
          <input
            type="text"
            placeholder="Secondary Processing Type"
            value={assessmentData.s_processing_type}
            onChange={(e) => setAssessmentData({ ...assessmentData, s_processing_type: e.target.value })}
            className="border p-2 rounded w-full mb-2"
          />
          <input
            type="number"
            placeholder="Weight (in grams)"
            value={assessmentData.weight_in_grams}
            onChange={(e) => setAssessmentData({ ...assessmentData, weight_in_grams: e.target.value })}
            className="border p-2 rounded w-full mb-2"
          />
          <input
            type="number"
            placeholder="Percentage"
            value={assessmentData.percentage}
            onChange={(e) => setAssessmentData({ ...assessmentData, percentage: e.target.value })}
            className="border p-2 rounded w-full mb-2"
          />
          <input
            type="text"
            placeholder="Comment"
            value={assessmentData.comment}
            onChange={(e) => setAssessmentData({ ...assessmentData, comment: e.target.value })}
            className="border p-2 rounded w-full mb-2"
          />

          <button onClick={addAssessmentData} className="bg-green-500 text-white px-4 py-2 rounded">
            Save Assessment
          </button>
        </div>
      )}

</SlidingDiv>

      {/* Display the assessment report */}
      {/* {selectedMineral && selectedMineral.assessment_report && (
        <div className="mt-4">
          <h3 className="text-lg font-semibold">Assessment Report</h3>
          <div className="border p-4 rounded">
            <p><strong>Processing Type:</strong> {selectedMineral.assessment_report.processing_type}</p>
            <p><strong>Weight (grams):</strong> {selectedMineral.assessment_report.weight_in_grams}</p>
            <p><strong>Assessment Result:</strong> {selectedMineral.assessment_report.assessment_result}</p>
          </div>
        </div>
      )} */}
    </div>
  );
}
